import React, { useState } from 'react';
import { Box, Drawer, Card, CardContent, Typography, CardHeader, CircularProgress } from '@mui/material';
import api from "../../../../services/api";
import FormAddEditToolbar from "../../../../components/global/AddEditBar";
import { useNavigate } from 'react-router-dom';
import { useNotifier } from "muinotify";
import CategoryItemTypeForm from "../CategoryItemTypeForm";
import useSWR, { mutate } from 'swr';
import ErrorNotification from '../../../../components/ErrorNotification/ErrorNotification';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
    pcit_aa: yup.number().nullable(true),
    pcit_descr: yup.string().required('Το πεδίο είναι υποχρεωτικό'),
});

const CategoryItemTypeAdd = () => {
    const navigate = useNavigate();
    const { notifier } = useNotifier();

    const [state, setState] = useState({
        pcit_descr: '',
        pcit_aa: 0,
    });

    const headerNames = {
        pcit_descr: 'Category Item Type Description',
        pcit_aa: 'Category Item Type AA',
    };

    const URL = `production-category-item-type`;
    const NAV_PATH = `category_item_type`;

    const [errorMessage, setErrorMessage] = useState();
    const [errors, setErrors] = useState({});
    const [isUpdating, setIsUpdating] = useState(false);

    function updateField(fieldName, value) {
        setState({ ...state, [fieldName]: value });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await validationSchema.validate(state, { abortEarly: false });
            setErrors({});
            setIsUpdating(true);
            api.post(`/${URL}/`, state)
                .then(response => {
                    mutate(`/${NAV_PATH}`);
                    notifier("New category item type inserted.", { variant: "success" });
                    setDrawerOpen(false);
                })
                .catch(error => {
                    setErrorMessage(error);
                    notifier(<ErrorNotification error={error} />, { variant: "error" });
                })
                .finally(() => {
                    setIsUpdating(false);
                    navigate(-1);
                });
        } catch (validationErrors) {
            const formattedErrors = {};
            validationErrors.inner.forEach((error) => {
                formattedErrors[error.path] = error.message;
            });
            setErrors(formattedErrors);
        }
    };

    const handleSave = () => {
        const form = document.getElementById(`${URL}-form`);
        if (form) {
            form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    const [drawerOpen, setDrawerOpen] = useState(true);

    return (
        <>
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleCancel}
                PaperProps={{
                    style: {
                        width: '100%',
                        height: '100vh',
                        maxWidth: '800px',
                        display: 'flex',
                        flexDirection: 'column',
                    },
                }}
            >
                <Card
                    sx={{
                        width: '100%',
                        maxWidth: 800,
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        textAlign: 'center',
                    }}
                >
                    {/* Header Section */}
                    <Box justifyContent="center" alignItems="center" width="100%">
                        <CardHeader
                            title={
                                <Typography variant="h3" gutterBottom>
                                    Προσθήκη τύπου στοιχείου κατηγορίας
                                </Typography>
                            }
                        />
                    </Box>

                    {/* Scrollable Content Section */}
                    <CardContent
                        sx={{
                            display: 'flex',
                            height: '100vh',
                            flexGrow: 1, // Allow this section to grow and shrink
                            overflowY: 'auto',
                            margin: 'initial',
                        }}
                    >
                        <form id={`${URL}-form`} onSubmit={handleSubmit}>
                            <CategoryItemTypeForm
                                state={state}
                                errors={errors}
                                updateField={updateField}
                                headerNames={headerNames}
                            />
                        </form>
                        {isUpdating && (
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                    zIndex: 1000,
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        )}
                    </CardContent>

                    {/* Toolbar (Footer Section) */}
                    <Box >
                        <FormAddEditToolbar
                            handleSave={handleSave}
                            handleCancel={handleCancel}
                        />
                    </Box>
                </Card>
            </Drawer >
        </>
    );
};

export default CategoryItemTypeAdd;
